module.exports = __webpack_public_path__ + "img/user.bd9d0c0d.svg";